/* Cart-page agreement only. This is not server-side checkout validation. */
(function () {
  'use strict';
  if (window.mswLegalConsentLoaded) return;
  window.mswLegalConsentLoaded = true;
  var loader = document.querySelector('[data-msw-legal-guard]');
  var cartUrl = loader ? loader.getAttribute('data-cart-url') : '/cart';
  var initialized = new WeakSet();

  function agreement(form) {
    return form && form.matches('[data-msw-consent-form]')
      ? form.querySelector('[data-msw-legal-checkbox]') : null;
  }

  function update(checkbox, showError) {
    var box = checkbox.closest('[data-msw-legal-box]');
    var error = box.querySelector('[data-msw-legal-error]');
    var timestamp = box.querySelector('[data-msw-legal-timestamp]');
    var invalid = !checkbox.checked && showError;
    checkbox.setCustomValidity(checkbox.checked ? '' : error.textContent.trim());
    checkbox.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    error.hidden = !invalid;
    box.classList.toggle('msw-legal-consent--error', !!invalid);
    timestamp.disabled = !checkbox.checked;
    timestamp.value = checkbox.checked ? (timestamp.value || new Date().toISOString()) : '';
  }

  function isCheckoutLink(link) {
    try {
      var url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin && /\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname);
    } catch (error) { return false; }
  }

  function initialize() {
    document.querySelectorAll('[data-msw-legal-checkbox]').forEach(function (checkbox) {
      if (initialized.has(checkbox)) return;
      initialized.add(checkbox);
      checkbox.checked = false;
      update(checkbox, false);
    });
    // Change ordinary shortcuts to cart links, including Ctrl/middle-click navigation.
    document.querySelectorAll('a[href*="/checkout"]').forEach(function (link) {
      if (!isCheckoutLink(link)) return;
      link.href = cartUrl + '#msw-cart-legal';
      link.setAttribute('data-no-instant', '');
    });
    document.querySelectorAll('form.atc-banner__form').forEach(function (form) {
      form.action = cartUrl;
      form.method = 'get';
      form.querySelectorAll('[name="checkout"]').forEach(function (button) {
        button.removeAttribute('name');
      });
    });
  }

  function stop(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function requireAgreement(event, form) {
    var checkbox = agreement(form);
    if (!checkbox) {
      stop(event);
      window.location.assign(cartUrl + '#msw-cart-legal');
      return false;
    }
    update(checkbox, !checkbox.checked);
    if (!checkbox.checked) {
      stop(event);
      checkbox.closest('[data-msw-legal-box]').scrollIntoView({block: 'center'});
      checkbox.focus({preventScroll: true});
      return false;
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var control = event.target.closest('button[name="checkout"], input[name="checkout"], .atc-button--checkout, a[href]');
    if (!control) return;
    if (control.tagName === 'A' && !isCheckoutLink(control)) return;
    requireAgreement(event, control.form || control.closest('form'));
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (event.submitter && event.submitter.formNoValidate) return;
    if (form.matches('[data-msw-consent-form], .atc-banner__form') ||
        (event.submitter && event.submitter.name === 'checkout')) {
      requireAgreement(event, form);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target instanceof Element && event.target.matches('[data-msw-legal-checkbox]')) update(event.target, false);
  });

  document.addEventListener('invalid', function (event) {
    if (!(event.target instanceof Element) || !event.target.matches('[data-msw-legal-checkbox]')) return;
    update(event.target, true);
    event.target.closest('[data-msw-legal-box]').scrollIntoView({block: 'center'});
  }, true);

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-msw-legal-checkbox]').forEach(function (checkbox) {
      checkbox.checked = false;
      update(checkbox, false);
    });
  });

  initialize();
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      initialize();
    });
  }).observe(document.body, {childList: true, subtree: true});
})();
